export default "__VITE_ASSET__BGquZv55__"